import { ElevesPDFSettings } from 'types/eleves';

interface Props {
  lng: string;
  settings: ElevesPDFSettings;
}

export function buildElevesParams({ lng, settings }: Props) {
  const params = new URLSearchParams({
    lng,
    landscape: (settings.landscape || false).toString(),
    fontSize: (settings.fontSize || 14).toString(),
    bgColor: settings.bgColor || 'white',
    marginTop: (settings.marginTop ?? 6).toString(),
    marginBottom: (settings.marginBottom ?? 6).toString(),
    marginLeft: (settings.marginLeft ?? 6).toString(),
    marginRight: (settings.marginRight ?? 6).toString(),
  });

  if (settings.font) {
    params.set('font', settings.font);
  }

  return params;
}
